// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"5b2ab873","109":"61e12d0a","138":"d045345c","421":"a65f6247","520":"9e9d5a6e","618":"9850cdad","774":"11043400","861":"3e3938d3"}[chunkId] + ".chunk.js";
};